import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Fragment } from 'react/jsx-runtime'
import { useParams } from 'react-router'
import { Base } from '@itsrever/design-system'
import { ReturnProcess } from '@/domain/returns'
import { EditProcess } from './edit-process/edit-process'
import { MarkAsRefunded } from './mark-as-refunded/mark-as-refunded'

const {
  Button,
  MenuRoot,
  MenuTrigger,
  MenuPortal,
  MenuPositioner,
  MenuPopup,
  MenuItem,
  DialogRoot,
  DialogPopup,
  DialogPortal,
  DialogBackdrop
} = Base

interface RefundMenuProps {
  process: ReturnProcess
}
export const RefundMenu = ({ process }: RefundMenuProps) => {
  const { t } = useTranslation()

  const { id } = useParams()

  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [markAsRefundedDialogOpen, setMarkAsRefundedDialogOpen] =
    useState(false)

  const isPendingRefund =
    parseFloat(
      process?.compensation?.statusSummary?.pendingRefundAmount?.amount ?? '0'
    ) > 0

  return (
    <Fragment>
      <MenuRoot>
        <MenuTrigger
          render={
            <Button
              size="sm"
              variant="secondary"
              className="px-2.5 text-xs data-[pressed]:bg-neutral-100"
            />
          }
        >
          {t('process_details_page.manage_refund')}
          <svg
            width="16px"
            height="16px"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            color="currentColor"
          >
            <path
              d="M6 9L12 15L18 9"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </MenuTrigger>
        <MenuPortal>
          <MenuPositioner sideOffset={8} align="end">
            <MenuPopup>
              <MenuItem
                className="font-roobert font-medium"
                onClick={() => setEditDialogOpen(true)}
              >
                {t('process_details_page.edit_refund')}
              </MenuItem>
              {isPendingRefund ? (
                <MenuItem
                  className="font-roobert font-medium"
                  onClick={() => setMarkAsRefundedDialogOpen(true)}
                >
                  {t('process_details_page.mark_as_refunded')}
                </MenuItem>
              ) : null}
            </MenuPopup>
          </MenuPositioner>
        </MenuPortal>
      </MenuRoot>

      <DialogRoot open={editDialogOpen} onOpenChange={setEditDialogOpen}>
        <DialogPortal>
          <DialogBackdrop />
          <DialogPopup className="scale-[calc(1-0.1*var(--nested-dialogs))]">
            <EditProcess
              process={process}
              onClose={() => setEditDialogOpen(false)}
            />
          </DialogPopup>
        </DialogPortal>
      </DialogRoot>
      <DialogRoot
        open={markAsRefundedDialogOpen}
        onOpenChange={setMarkAsRefundedDialogOpen}
      >
        <DialogPortal>
          <DialogBackdrop />
          <DialogPopup className="scale-[calc(1-0.1*var(--nested-dialogs))]">
            <MarkAsRefunded
              processId={id!}
              onClose={() => setMarkAsRefundedDialogOpen(false)}
            />
          </DialogPopup>
        </DialogPortal>
      </DialogRoot>
    </Fragment>
  )
}
